import React, { useCallback, useRef } from 'react'
import { useMemo } from 'react'
import { partnerColumns } from './columns/_columns'
import Partner from '../../../../interfaces/Partner'
import GenericTable, {
  GenericTableHandle
} from '../../../../components/GenericTable'
import {
  PaginatedResponse,
  PaginationMeta
} from '../../../../interfaces/PaginatedResponse'
import { list } from '../../../../lib/fetch/partners'
import { useAuth } from '../../../../context/Auth'

interface PartnerTableProps {
  filters: any
}

const PartnerTable = ({ filters }: PartnerTableProps) => {
  const ref = useRef<GenericTableHandle>(null)
  const [{ token }] = useAuth()
  const columns = useMemo(() => partnerColumns, [])

  const fetch = useCallback(
    async (
      paginationMeta: PaginationMeta
    ): Promise<PaginatedResponse<Partner> | string> => {
      let result
      try {
        result = await list({
          token,
          page: paginationMeta.currentPage,
          limit: paginationMeta.itemsPerPage,
          ...filters
        })
      } catch (error) {
        let message = 'Error'
        if (error instanceof Error) {
          message = error.message
        }
        result = message
      }
      return result
    },
    [filters, token]
  )

  return <GenericTable columns={columns} onFetch={fetch} ref={ref} />
}

export { PartnerTable }
